import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyPortfolioTeamRoute: InvariantJiraRoute = {
	name: 'legacy-portfolio-team',
	path: '/secure/TeamManagement.jspa',
};
